import { Reveal } from "./Reveal";
import { TEAM, SERVICE_AREAS } from "@/data";
import { MapPin } from "lucide-react";

export const Team = () => (
  <section className="bg-paper text-ink py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-7">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-rust">Meet The Owner</span>
            <h2 className="mt-5 font-display font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              The owner behind every turnaround.
            </h2>
            <p className="mt-6 text-lg text-ink/60 max-w-xl leading-relaxed">
              Garage Cleaners was built on one promise — take the time, the guesswork, and the stress off your plate.
              One owner, on every job, personally accountable for the result.
            </p>
          </Reveal>

          <div className="mt-12 max-w-sm">
            {TEAM.map((m, i) => (
              <Reveal key={m.name} delay={i * 0.1}>
                <div data-testid={`team-${i}`}>
                  <div className="aspect-[4/5] overflow-hidden bg-ink/5 clip-frame">
                    <img src={m.img} alt={m.name} loading="lazy" decoding="async" width="760" height="1013" className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500" />
                  </div>
                  <h3 className="mt-5 font-display font-bold text-2xl">{m.name}</h3>
                  <p className="font-mono text-xs uppercase tracking-widest text-rust mt-1">{m.role}</p>
                  <p className="mt-3 text-ink/60 leading-relaxed">{m.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.15}>
            <div className="border border-ink/10 bg-cream p-8 lg:p-10 lg:sticky lg:top-28">
              <div className="flex items-center gap-2 text-rust">
                <MapPin size={18} />
                <span className="font-mono text-xs uppercase tracking-[0.2em]">Service Area</span>
              </div>
              <h3 className="mt-5 font-display font-bold text-3xl">Serving the Twin Cities metro.</h3>
              <p className="mt-3 text-ink/60">Owned and run right here in the Twin Cities. If you're within about 20 miles of Minneapolis or St. Paul, we've got you covered.</p>
              <div className="mt-8 flex flex-wrap gap-2">
                {SERVICE_AREAS.map((a) => (
                  <span key={a} className="border border-ink/15 px-3 py-1.5 text-sm text-ink/70 hover:border-rust hover:text-rust transition-colors">
                    {a}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
